import VueCookie from 'vue-cookie'
import Router from '../router/index.js'
import Axios from 'axios'

const Kvs = {
  state: {
    namespaces: null,
    namespace: null,
    types: null,
    type: null,
    typeHeaders: null,
    entities: null,
    entity: null
  },
  getters: {
    get_namespaces: (state) => {
      return state.namespaces
    },
    get_namespace: (state) => {
      return state.namespace
    },
    get_types: (state) => {
      return state.types
    },
    get_type: (state) => {
      return state.type
    },
    get_typeHeaders: (state) => {
      return state.typeHeaders
    },
    get_entities: (state) => {
      return state.entities
    },
    get_entity: (state) => {
      return state.entity
    }
  },
  mutations: {
    set_namespaces: (state, payload) => {
      state.namespaces = payload
    },
    set_namespace: (state, payload) => {
      state.namespace = payload
    },
    set_types: (state, payload) => {
      state.types = payload
    },
    set_type: (state, payload) => {
      state.type = payload
    },
    set_typeHeaders: (state, payload) => {
      state.typeHeaders = payload
    },
    set_entities: (state, payload) => {
      state.entities = payload
    },
    set_entity: (state, payload) => {
      state.entity = payload
    }
  },
  actions: {
    api_index_namespaces: (context) => {
      Axios.get(process.env.VUE_APP_JOAT_URL + '/kv/namespaces', {
        headers: {
          Authorization: context.rootGetters['Projects/get_firstKey']
        }
      })
        .then(response => {
          context.commit('set_namespaces', response.data)
        })
    },

    api_index_types: (context) => {
      const namespaceId = context.getters.get_namespace ? context.getters.get_namespace.id : null
      Axios.get(process.env.VUE_APP_JOAT_URL + '/kv/namespaces/' + namespaceId + '/types', {
        headers: {
          Authorization: context.rootGetters['Projects/get_firstKey']
        }
      })
        .then(response => {
          context.commit('set_types', response.data)
        })
    },

    api_one_type: (context) => {
      const namespaceId = context.getters.get_namespace ? context.getters.get_namespace.id : null
      const typeId = context.getters.get_type ? context.getters.get_type.id : null
      Axios.get(process.env.VUE_APP_JOAT_URL + '/kv/namespaces/' + namespaceId + '/types/' + typeId, {
        headers: {
          Authorization: context.rootGetters['Projects/get_firstKey']
        }
      })
        .then(response => {
          context.commit('set_type', response.data)
        })
    },
    api_create_namespace: (context, payload) => {
      Axios.post(process.env.VUE_APP_JOAT_URL + '/kv/namespaces', { name: payload.name }, {
        headers: {
          Authorization: context.rootGetters['Projects/get_firstKey']
        }
      })
        .then(response => {
          context.dispatch('api_index_namespaces')
        })
    },
    api_create_type: (context, payload) => {
      const namespaceId = context.getters.get_namespace ? context.getters.get_namespace.id : null
      Axios.post(process.env.VUE_APP_JOAT_URL + '/kv/namespaces/' + namespaceId + '/types', { name: payload.name }, {
        headers: {
          Authorization: context.rootGetters['Projects/get_firstKey']
        }
      })
        .then(response => {
          context.dispatch('api_index_types')
        })
    },
    api_create_entity: (context, payload) => {
      const namespaceId = context.getters.get_namespace ? context.getters.get_namespace.id : null
      const typeId = context.getters.get_type ? context.getters.get_type.id : null
      Axios.post(process.env.VUE_APP_JOAT_URL + '/kv/namespaces/' + namespaceId + '/types/' + typeId + '/entities', JSON.stringify(payload.data), {
        headers: {
          Authorization: context.rootGetters['Projects/get_firstKey']
        }
      })
        .then(response => {
          context.dispatch('api_one_type')
        })
    },
    api_create_property: (context, payload) => {
      const namespaceId = context.getters.get_namespace ? context.getters.get_namespace.id : null
      const typeId = context.getters.get_type ? context.getters.get_type.id : null
      const entityId = context.getters.get_entity ? context.getters.get_entity.id : null
      Axios.post(process.env.VUE_APP_JOAT_URL + '/kv/namespaces/' + namespaceId + '/types/' + typeId + '/entities/' + entityId + '/properties', { data: JSON.stringify(payload) }, {
        headers: {
          Authorization: context.rootGetters['Projects/get_firstKey']
        }
      })
        .then(response => {
          context.dispatch('api_one_type')
        })
    },
    api_update_property: (context, payload) => {
      const namespaceId = context.getters.get_namespace ? context.getters.get_namespace.id : null
      const typeId = context.getters.get_type ? context.getters.get_type.id : null
      const entityId = context.getters.get_entity ? context.getters.get_entity.id : null
      const propertyId = payload.id ? payload.id : null
      Axios.put(process.env.VUE_APP_JOAT_URL + '/kv/namespaces/' + namespaceId + '/types/' + typeId + '/entities/' + entityId + '/properties/' + propertyId, { name: payload.name, value: payload.value, datatype: payload.datatype }, {
        headers: {
          Authorization: context.rootGetters['Projects/get_firstKey']
        }
      })
        .then(response => {
          context.dispatch('api_one_type')
        })
    },
    api_delete_property: (context, payload) => {
      const namespaceId = context.getters.get_namespace ? context.getters.get_namespace.id : null
      const typeId = context.getters.get_type ? context.getters.get_type.id : null
      const entityId = context.getters.get_entity ? context.getters.get_entity.id : null
      const propertyId = payload.id ? payload.id : null
      Axios.delete(process.env.VUE_APP_JOAT_URL + '/kv/namespaces/' + namespaceId + '/types/' + typeId + '/entities/' + entityId + '/properties/' + propertyId, {
        headers: {
          Authorization: context.rootGetters['Projects/get_firstKey']
        }
      })
        .then(response => {
          context.dispatch('api_one_type')
        })
    }
  },
  namespaced: true
}
export default Kvs
